<template>
  <div class="sticky-navigation">
    <nav class="nav">
      <ul v-scroll-spy-active="{selector: `li>a` }">
        <li
          v-for="(link, i) in navigationLinks"
          :key="i"
          v-show="link.name"
        >
          <a :href="`#`" v-scroll-to="{ el: '#link-' + i, container: 'body',}">{{ link.name }}</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "sticky-navigation",
  props: { navigationLinks: Array },
  data() {
    return {
      navigation: null,
      navigationOffsetTop: null,
      links: ["our approach", "our values"]
    };
  },

  methods: {
    handleScroll(event) {
      if (window.pageYOffset > this.navigationOffsetTop) {
        this.navigation.classList.add("sticky");
      } else {
        this.navigation.classList.remove("sticky");
      }
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  mounted: function() {
    this.navigation = document.querySelector(".sticky-navigation");
    this.navigationOffsetTop = this.navigation.offsetTop;
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>


// WEBPACK FOOTER //
// StickyNavigation.vue?290dfe9d